import { DatePipe } from '@angular/common';
import { Component, Inject, LOCALE_ID } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DeviceDetectorService } from 'ngx-device-detector';
import { JobFilter } from '../../job/models/job.filter';
import { JobService } from '../../job/services/job.service';
import { Crew } from '../../shared/models/crew.interface';
import { FieldTechnician } from '../../shared/models/field.technician.interface';
import { Job } from '../../shared/models/job.interface';
import { MonthType } from '../../shared/models/month.type.interface';
import { FileService } from '../../shared/services/file.service';
import { WorkOrderService } from '../../work-order/services/work.order.service';
import { AbstractReportComponent } from '../abstract.report.component';
import { PayrollSummary, PayrollSummaryResult } from '../models/payroll.summary.interface';
import { ReportService } from '../services/report.service';

export interface PayrollSummaryParameterData {
  payrollSummary: PayrollSummary;
  validation: string;

  jobs: Job[];
  crews: Crew[];
  fieldTechnicians: FieldTechnician[];
  startDate: Date;
  endDate: Date;
}

@Component({
    selector: 'app-payroll-summary',
    templateUrl: './payroll-summary.component.html',
    styleUrls: ['./payroll-summary.component.scss']
})
/** payrollSummary component*/
export class PayrollSummaryComponent extends AbstractReportComponent {

  report: PayrollSummaryResult = null;
  parameters: PayrollSummary = {
    startDate: '',
    endDate: ''
  } as PayrollSummary;

  job: Job;
  crew: Crew;
  fieldTechnician: FieldTechnician;

  jobs: Job[];
  crews: Crew[];
  fieldTechnicians: FieldTechnician[];

  startDate = new Date();
  endDate = new Date();

    /** payrollSummary ctor */
  constructor(@Inject(LOCALE_ID) locale: string,
    deviceDetectorService: DeviceDetectorService, private datepipe: DatePipe,
    dialog: MatDialog, private jobService: JobService, private workOrderService: WorkOrderService,
    private reportService: ReportService, private fileService: FileService) {
    super(locale, dialog, deviceDetectorService);

    this.startDate.setMonth(this.endDate.getMonth() - 1);

    this.jobService.getJobList()
      .subscribe({
        next: (data) => {
          this.jobs = data;
          this.showParameters();
        },
        error: (error: string) => this.onError(error)
      });

    this.jobService.getCrews()
      .subscribe({
        next: (data) => {
          this.crews = data;
          this.showParameters();
        },
        error: (error: string) => this.onError(error)
      });

    this.workOrderService.getFieldTechs()
      .subscribe({
        next: (data) => {
          this.fieldTechnicians = data;
          this.showParameters();
        },
        error: (error: string) => this.onError(error)
      });

    this.setupDates();
  }

  renderReport() {
    this.getReportFormat()
      .subscribe(formatData => {
        if (formatData == null) return;

        this.isRequesting = true;
        this.reportService.getPayrollSummaryExport(this.parameters, formatData.format, formatData.locale)
          .subscribe({
            next: (data) => {
              this.isRequesting = false;
              this.fileService.downloadFile(data, 'PayrollSummary' + formatData.extension);
            },
            error: (error: string) => this.onError(error)
          });
      });
  }

  showParameters() {
    if (this.jobs == null ||
      this.crews == null ||
      this.fieldTechnicians == null) return;

    const dialogRef = this.dialog.open(PayrollSummaryParameterDialog, {
      width: '550px',
      data: {
        payrollSummary: (<any>Object).assign({}, this.parameters),

        jobs: this.jobs,
        crews: this.crews,
        fieldTechnicians: this.fieldTechnicians,

        startDate: this.startDate,
        endDate: this.endDate
      } as PayrollSummaryParameterData
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      if (result) {
        this.parameters = result.payrollSummary as PayrollSummary;
        this.startDate = result.startDate;
        this.endDate = result.endDate;

        this.parameters.startDate = this.datepipe.transform(this.startDate, 'yyyy-MM-ddT00:00:00');
        this.parameters.endDate = this.datepipe.transform(this.endDate, 'yyyy-MM-ddT00:00:00');

        this.job = this.jobs.find(s => s.quote_ID == this.parameters.quote_ID);
        this.crew = this.crews.find(s => s.crew_ID == this.parameters.crew_ID);
        this.fieldTechnician = this.fieldTechnicians.find(s => s.fieldTechnician_ID == this.parameters.fieldTechnician_ID);

        this.reportService.getPayrollSummaryReport(this.parameters)
          .subscribe({
            next: (data) => {
              this.report = data;
            },
            error: (error: string) => this.onError(error)
          });
      }
    });
  }
}

@Component({
  selector: 'payroll-summary.parameter.dialog',
  templateUrl: 'payroll-summary.parameter.dialog.html',
})
export class PayrollSummaryParameterDialog {

  errors: string = '';

  constructor(
    public dialogRef: MatDialogRef<PayrollSummaryParameterDialog>,
    @Inject(MAT_DIALOG_DATA) public data: PayrollSummaryParameterData) { }

  runReport(form: NgForm): void {
    this.errors = '';

    if (form.valid) {
      this.dialogRef.close(this.data);
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
